import {EnvironmentTypes} from '../app/Enums/environment-types';

export const environment = {
    tenant: EnvironmentTypes.VSA,
    production: true,
    redirectUri: 'https://test.arp.3d5.at/',
    postLogoutRedirectUri: 'https://test.arp.3d5.at/',
    arpApiUrl: 'https://arp-api-testing.azurewebsites.net',
    portalUrl: 'https://arp-portal-test.azureedge.net/?autoredirect=false',
    msalAuthority: 'https://login.microsoftonline.com/a76381c7-ea6e-41f4-8bb8-cb6ec292a8a0',
    msalClientId: '88c742ed-c62f-4d63-a157-9d793776d2d0',
    authScopes: [
        {
            apiUrl: 'https://arp-api-testing.azurewebsites.net/v2_0',
            scope: 'api://b9adb64b-0694-4c19-a5be-8ba3e5b60641/Api.ReadWrite.All'
        }
    ]
};
